import React from "react";

import { FLAVORS_EFFECTS_DISCLAIMER } from "@/constants/strains";
import { StrainTag } from "@/custom-types/StrainTags";
import useDomainCountryCode from "@/hooks/useDomainCountryCode";

import Carousel from "@/components/botanic/Carousel";
import EffectIcon from "@/components/Icons/EffectIcon";
import EllipseIcon from "@/components/Icons/ellipse_filled.svg";
import IconTile from "@/components/IconTile";
import TooltipCTA from "@/components/StrainPage/TooltipCTA";

type Props = {
  effects: StrainTag[];
};

const StrainEffectTiles = ({ effects }: Props) => {
  const countryCode = useDomainCountryCode();
  // Return null if no effects are provided, and there isn't a no results display provided
  if (!effects) {
    return null;
  }

  return (
    <div className="py-xxl">
      <h2 className="text-md mb-md">Browse weed strains by effect</h2>
      <div className="lg:-mb-xl">
        <TooltipCTA
          sectionName="effects"
          title="Reported by real people like you"
          tooltipText={FLAVORS_EFFECTS_DISCLAIMER}
          shouldShowTooltip={countryCode === "US"}
        />
      </div>
      <Carousel cardsPerSlide={6} mobileCardWidth={100}>
        {effects.map(({ slug }) => (
          <IconTile
            title={slug}
            link={`/strains/lists/effect/${slug}`}
            eventCategory="Strain List Tile"
            key={slug}
          >
            <div className="relative">
              <div className="relative z-10">
                <EffectIcon
                  width="65"
                  height="30"
                  className="block relative z-10"
                  effect={slug}
                />
              </div>
              <span
                className="absolute opacity-25 text-green-60"
                style={{
                  right: "20px",
                  top: "10px",
                }}
              >
                <EllipseIcon width="27" height="20" />
              </span>
            </div>
          </IconTile>
        ))}
      </Carousel>
    </div>
  );
};

export default StrainEffectTiles;
